import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';

import { IMyDateModel, IMyDpOptions } from 'mydatepicker';
import { ModulosController } from '../../modulos-controller';

import { TomadaDeContaService } from '../../../../providers/tce-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';

import { ModalResponsavelTcePage } from '../../../modais/modal-responsavel-tce/modal-responsavel-tce';

declare var jsPDF: any;

@Component({
  selector: 'page-tce-exercicio',
  templateUrl: 'tce-exercicio.html',
  providers: [
    TomadaDeContaService
  ]
})
export class TomadaDeContaPage extends ModulosController {

  motivos: any = [
    { 
      name: "Não Finalizado", 
      value: "nao_finalizado" }, 
    { 
      name: "Arquivado no Órgão", 
      value: "arquivado" }
    ];
  
  detMotivos: any = [
    {
      name: "Recolhimento",
      value: "recolhimento"
    }, 
    {
      name: "Dano Inferior ao Limite para Encaminhamento ao Tribunal",
      value: "dano_inferior"
    }, 
    { 
      name: "Não Ocorrência de Dano", 
      value: "nao_ocorrencia" 
    },
    {
      name: "TCE em análise",
      value: "em_analise"
    }
    ];

  idModuloAnalise: any;
  listaFatores: any = [];
  listaTCE: any = [];
  listaEdit: any = [];
  comboFatoGerador: any = null;
  comboMotivo: any = null;
  comboDetMotivo: any = null;
  objetoEdit: any = null;
  myDatePickerDataPub: IMyDpOptions;

  placeholder: string = 'Informe a Data'
  cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  procMask = [/\d/, /\d/, /\d/, /\d/, /\d/,'/', /\d/, /\d/, /\d/, /\d/, '-', /\d/];

  cpfConvInvalido: boolean = false;
  cnpjInvalido: boolean = false;

  @ViewChild('inputCnpj') inputCnpj: ElementRef;
  @ViewChild('inputCpf') inputCpf: ElementRef;

  habilita: boolean = false;

  flTipo: any = 'true';

  verificacao: boolean = true;

  inciso: string = ""
  incisoI: string = "I - nos casos de omissão no dever de prestar contas, do primeiro dia subsequente ao vencimento do prazo para apresentação da prestação de contas.";
  incisoII: string = "II - nos casos em que os elementos constantes das contas apresentadas não permitirem a conclusão de que a aplicação dos recursos observou as normas pertinentes e/ou atingiu os fins colimados, da data limite para análise da prestação de contas";
  incisoIII: string = "III - nos demais casos, da data do evento ilegítimo ou antieconômico, quando conhecida, ou da data da ciência do fato pela administração.";

  objetoTCE: any = {
    "id": "",
    "nmSacc": "",
    "nmSic": "",
    "nmPortaria": "",
    "dataPublicacao": "",
    "nomeConvenente": "",
    "valor": "",
    "responsaveis": [],
    "cpfConv": "",
    "cnpj": "",
    "dano": "",
    "danoFinal": "",
    "situacao": "",
    "ds_situacao": "",
    "flEnviada": "",
    "protocolo": "",
    "processo": "",
    "motivo": "",
    "detMotivo": "",
    "medidasAdm": "",
    "idModuloAnalise": ""
  }

  analise: any = null;

  loading: boolean = true;

  @ViewChild('inputFileCM')
  inputFileCMVar: ElementRef;

  selecionarTodosChecked = false;
  desabilitarImportacao = true;
  
  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public navParams: NavParams,
    public tomadaDeContaService: TomadaDeContaService,
    public gestaoPcaService: GestaoPcaService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    private menuService: MenuService,
    private renderer: Renderer2) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.analise = this.navParams.get('analise');

    this.myDatePickerDataPub = {
      dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: {
        1: 'Jan',
        2: 'Fev',
        3: 'Mar',
        4: 'Abr',
        5: 'Mai',
        6: 'Jun',
        7: 'Jul',
        8: 'Ago',
        9: 'Set',
        10: 'Out',
        11: 'Nov',
        12: 'Dez'
      },
      dateFormat: 'dd/mm/yyyy',
      todayBtnTxt: 'Hoje',
      firstDayOfWeek: 'su',
      disableWeekends: false,
      editableDateField: true,
      openSelectorOnInputClick: true,
      showClearDateBtn: false
    };

    this.idModuloAnalise = this.navParams.get('analise').idModuloAnalise;
    //this.isJurisdicionado = this.usuarioService.isJurisdicionado();
    this.isCGE = this.usuarioService.isCGE();
    this.carregarModulo();
    this.setModuloId(9);
  }

  carregarModulo() {
    this.listarTCE()
    this.carregarFatores();
  }

  listarTCE() {
    this.desabilitarImportacao = true;
    this.loading = true;
    this.tomadaDeContaService.listarTomadaDeConta().subscribe(data => {
      this.listaTCE = data;
      this.desabilitarImportacao = this.listaTCE.length > 0;
      this.selecionarTodosChecked = false;
      this.loading = false;
    }, error => {
      this.loading = false;
      console.log("erro: " + error);
      this.alertService.mostraAlerta("", "Houve um problema ao listar as Tomadas de Contas.");
    });
  }

  onDatePickerDataPub(event: IMyDateModel) {
    if (event.jsdate === null) {
      this.objetoTCE.dataPublicacao = null;
    }
    else {
      this.objetoTCE.dataPublicacao = new Date(event.jsdate).toLocaleDateString('pt-br');
    }
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  voltarParaTomadaDeconta() {
    this.menuService.redirecionarPagina(this.tomadaDeContaService.obterIdPaginaTomadaDeConta());
  }

  templateCargaEmMassa() {
    this.tomadaDeContaService.baixarTemplateTomadaDeConta();
  }

  cargaEmMassa(event) {
    this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?",
      retornoModal => {
        if (retornoModal) {
          this.loading = true; 
          this.tomadaDeContaService.cargaMassa(event).subscribe(data => {
            this.inputFileCMVar.nativeElement.value = "";

            if(data && data.length > 0){
              this.selecionarTodosChecked = false;
            }
            
            for (let item of data) {
              this.listaTCE.push(item);
            }

            this.alertService.mostraAlerta("Importação concluída.","Para efetivar a importação, clique em salvar ou finalizar.");
            this.loading = false;
          }, error => {
            this.inputFileCMVar.nativeElement.value = "";
            this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error.mensagem);
            this.loading = false;
          });
        } else {
          this.inputFileCMVar.nativeElement.value = "";
        }
      }
    );
  }

  verificarListaResponsaveis(responsaveis): boolean {
    if (responsaveis != null && responsaveis.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  adicionarTCE() {
    
    //Tomada de Contas Especial enviada ao TCE-CE conforme instrução normativa?
    if (this.objetoTCE.flEnviada == false) {
      
      if (this.objetoTCE.motivo != '' && this.objetoTCE.motivo != "nao_finalizado") {
       
        if (this.objetoTCE.detMotivo != '') {
          if (this.objetoTCE.detMotivo == 'dano_inferior' && this.objetoTCE.medidasAdm == '') {
            this.verificacao = false;
          } else {
            this.verificacao = true;
          }
        } else {
          this.verificacao = false;
        }

      } else if (this.objetoTCE.motivo != '' && this.objetoTCE.motivo == "nao_finalizado") {
        
        this.verificacao = true;
      } else {
        
        this.verificacao = false;
      }

    } else {
      
      if (this.objetoTCE.protocolo != '' || this.objetoTCE.processo != '') {
        this.verificacao = true;
      } else {
        this.verificacao = false;
      }
    
    }

    if (this.objetoTCE.valor == "" || this.objetoTCE.valor == null || this.objetoTCE.valor == undefined || isNaN(this.objetoTCE.valor)) {
      this.objetoTCE.valor = 0;
    }

    if (this.objetoTCE.dano == "" || this.objetoTCE.dano == null || this.objetoTCE.dano == undefined || isNaN(this.objetoTCE.dano)) {
      this.objetoTCE.dano = 0;
    }
  
    if (this.objetoTCE.danoFinal == "" || this.objetoTCE.danoFinal == null || this.objetoTCE.danoFinal == undefined || isNaN(this.objetoTCE.danoFinal)) {
      this.objetoTCE.danoFinal = 0;
    }

    let validaTipo = false;
    
    if (this.flTipo == "false") {
      validaTipo = true;
    
    } else {
     
      if (this.objetoTCE.nmSacc != ''
        && this.objetoTCE.nmSic != ''
        && this.objetoTCE.nomeConvenente != ''
        && this.objetoTCE.valor != 0
        ) {
        validaTipo = true;
      } else {
        validaTipo = false;
      }
    }

    if (this.verificacao) {

      if (!this.cpfConvInvalido && !this.cnpjInvalido) {
        
        if (
          this.objetoTCE.nmPortaria != '' &&
          this.objetoTCE.dataPublicacao != '' &&
          validaTipo &&
          this.objetoTCE.dano != 0 &&
          this.objetoTCE.ds_situacao != '') {

          if (this.objetoTCE.cpfConv) {
            this.objetoTCE.cpfConv = this.objetoTCE.cpfConv.replace(/\D/g, '');
          }

          if (this.objetoTCE.cnpj) {
            this.objetoTCE.cnpj = this.objetoTCE.cnpj.replace(/\D/g, '');
          }

          let objetoTCE = {
            "id": this.objetoTCE.id != 0 ? this.objetoTCE.id : 0,
            "nmSacc": this.objetoTCE.nmSacc,
            "dataPublicacao": this.objetoTCE.dataPublicacao,
            "nomeConvenente": this.objetoTCE.nomeConvenente,
            "valor": parseFloat(this.objetoTCE.valor.toString().trim().replace(',', '.')),
            "responsaveis": this.verificarListaResponsaveis(this.objetoTCE.responsaveis) ? this.objetoTCE.responsaveis : [],
            "dano": parseFloat(this.objetoTCE.dano.toString().trim().replace(',', '.')),
            "situacao": this.objetoTCE.situacao,
            "ds_situacao": this.objetoTCE.ds_situacao,
            "protocolo": this.objetoTCE.protocolo,
            "processo": this.objetoTCE.processo,
            "motivo": this.objetoTCE.motivo,
            "flEnviada": this.objetoTCE.flEnviada,
            "nmSic": this.objetoTCE.nmSic,
            "nmPortaria": this.objetoTCE.nmPortaria,
            "cpfConv": this.objetoTCE.cpfConv,
            "cnpj": this.objetoTCE.cnpj,
            "danoFinal": this.objetoTCE.danoFinal,
            "detMotivo": this.objetoTCE.detMotivo,
            "medidasAdm": this.objetoTCE.medidasAdm,
            "idModuloAnalise": this.objetoTCE.idModuloAnalise != 0 || this.objetoTCE.idModuloAnalise != "" ? this.objetoTCE.idModuloAnalise : 0
          }

          if (this.objetoEdit) {
            let index = this.listaTCE.indexOf(this.objetoEdit);
            this.listaTCE.splice(index, 1);

            this.listaEdit.push(this.objetoEdit);
          }

          this.selecionarTodosChecked = false;
          this.listaTCE.push(objetoTCE);

          this.comboMotivo = null;
          this.comboDetMotivo = null;
          this.comboFatoGerador = null;
          this.objetoEdit = null;
          this.inciso = "";

          this.objetoTCE.nmSacc = '';
          this.objetoTCE.dataPublicacao = null;
          this.objetoTCE.nomeConvenente = '';
          this.objetoTCE.valor = '';
          this.objetoTCE.responsaveis = [];
          this.objetoTCE.dano = '';
          this.objetoTCE.situacao = '';
          this.objetoTCE.ds_situacao = '';
          this.objetoTCE.protocolo = '';
          this.objetoTCE.processo = '';
          this.objetoTCE.motivo = '';
          this.objetoTCE.flEnviada = null;          
          this.objetoTCE.nmSic = '';
          this.objetoTCE.nmPortaria = '';
          this.objetoTCE.cpfConv = '';
          this.objetoTCE.cnpj = '';
          this.objetoTCE.danoFinal = '';
          this.objetoTCE.detMotivo = '';
          this.objetoTCE.medidasAdm = '';
          this.objetoTCE.idModuloAnalise = 0;

          let copy = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: {
              1: 'Jan',
              2: 'Fev',
              3: 'Mar',
              4: 'Abr',
              5: 'Mai',
              6: 'Jun',
              7: 'Jul',
              8: 'Ago',
              9: 'Set',
              10: 'Out',
              11: 'Nov',
              12: 'Dez'
            },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false
          }
          this.myDatePickerDataPub = copy;
        
        } else {
          this.alertService.mostraAlerta("", "Verifique os campos do formulário não preenchidos.");
        }
      } else {
        this.alertService.mostraAlerta("", "O CPF/CNPJ informado é inválido.");
      }
    
    } else {
      
      if (this.objetoTCE.flEnviada == "true") {
        this.alertService.mostraAlerta("", "O número do Protocolo ou Processo é Obrigatório.");
      } else {
        if (this.objetoTCE.motivo == '') {
          this.alertService.mostraAlerta("", "O Motivo é Obrigatório.");
        } else if (this.objetoTCE.detMotivo == '' && this.objetoTCE.motivo == 'arquivado') {
          this.alertService.mostraAlerta("", "O Detalhamento do Motivo é Obrigatório.");
        } else if (this.objetoTCE.detMotivo == 'dano_inferior' && this.objetoTCE.medidasAdm == '') {
          this.alertService.mostraAlerta("", "As Medidas Administrativas são Obrigatórias.");
        }
      }
    }
  }

  salvar() {

    this.listaEdit.forEach(item => {
      this.removerTCE(item, true);
    });

    this.listaEdit = [];

    this.tomadaDeContaService.salvarTomadaDeConta(this.listaTCE).subscribe(data => {
      this.alertService.mostraAlerta("", "Tomada de Conta salva com sucesso.");
      this.carregarModulo();
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar a Tomada de Conta:" + error.mensagem);
    });
  }

  carregarFatores() {
    this.tomadaDeContaService.listarFatoresGeradores().subscribe(data => this.listaFatores = data, error => console.log("erro: " + error));
  }

  onFatoresChange(novoValor) {

    this.objetoTCE.situacao = novoValor.codigo;
    this.objetoTCE.ds_situacao = novoValor.valor;

    if (this.objetoTCE.situacao == 1) {
      this.inciso = this.incisoI;
    }

    if (this.objetoTCE.situacao == 2) {
      this.inciso = this.incisoII;
    }

    if (this.objetoTCE.situacao == 3) {
      this.inciso = this.incisoIII;
    }

  }

  removerTCE(item, edit) {
    if (!edit) {
      this.alertService.mostraModalConfirmacao("Remover Item", "Deseja remover o item?", callback => {
        if (callback) {

          this.listaTCE = this.listaTCE.filter(obj => obj !== item);
          let index = this.listaTCE.indexOf(item);
          this.listaTCE.splice(index, 1);

          if (item.id != 0) {
            this.deletarTCE(item.id);
          }
        }
      });
    } else {
      if (item.id != 0) {
        this.deletarTCE(item.id);
      }
    }
  }

  deletarTCE(idTCE) {
    this.tomadaDeContaService.deletarTomadaDeConta(idTCE).subscribe(data => {

    });
  }

  excluirSelecionados(){

    let qtdeSelecionados = 0; 
    this.listaTCE.forEach(item => qtdeSelecionados += item.checked);
    
    if(qtdeSelecionados == 0) {
        this.alertService.mostraAlerta("", "Selecione pelo menos um registro para excluir!");
        return;
    }

    let registrosTexto = qtdeSelecionados + (qtdeSelecionados == 1 ? " registro?" : " registros?");

    this.alertService.mostraModalConfirmacao("Excluir " + registrosTexto, 
        "Deseja continuar com a exclusão de " 
            + registrosTexto + "<br/>" 
            + "Após a exclusão, os registros serão recarregados. Certifique-se de salvar possíveis alterações antes de prosseguir!", 
        callback => {            
            if (callback) {
                this.loading = true;
                                    
                let listaId = this.listaTCE
                    .filter(item => item.checked)
                    .map(item => item.id);
                
                this.tomadaDeContaService.deletarLista(listaId, this.selecionarTodosChecked, this.idModuloAnalise).subscribe(data => {
                    this.listarTCE();
                    this.alertService.mostraAlerta("", data.mensagem);
                }, error => {
                    this.listarTCE();
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir: " + error.mensagem);
                });
            }
        }
    );        
}

  editarTCE(item) {

    this.objetoTCE.responsaveis = [];

    item.responsaveis.forEach(r => {

      let resp = {
        "idResponsavel": 0,
        "cpf": '',
        "nomeResponsavel": ''
      };

      resp.cpf = r.cpf;
      resp.nomeResponsavel = r.nomeResponsavel;

      this.objetoTCE.responsaveis.push(resp);
    });

    this.objetoTCE.nmSacc = item.nmSacc;
    this.objetoTCE.nmSic = item.nmSic;
    this.objetoTCE.nmPortaria = item.nmPortaria;
    this.objetoTCE.dataPublicacao = item.dataPublicacao;
    this.objetoTCE.nomeConvenente = item.nomeConvenente;
    this.objetoTCE.valor = item.valor;
    this.objetoTCE.cpfConv = item.cpfConv;
    this.objetoTCE.cnpj = item.cnpj;
    this.objetoTCE.dano = item.dano;
    this.objetoTCE.danoFinal = item.danoFinal;
    this.objetoTCE.situacao = item.situacao;
    this.objetoTCE.ds_situacao = item.ds_situacao;
    this.objetoTCE.flEnviada = item.flEnviada;
    this.objetoTCE.protocolo = item.protocolo;
    this.objetoTCE.processo = item.processo;
    this.objetoTCE.motivo = item.motivo;
    this.objetoTCE.detMotivo = item.detMotivo;
    this.objetoTCE.medidasAdm = item.medidasAdm;
    this.objetoTCE.idModuloAnalise = item.idModuloAnalise;

    this.listaFatores.forEach(fator => {
      if (fator.codigo == this.objetoTCE.situacao) {
        this.comboFatoGerador = fator;
      }
    });

    this.motivos.forEach(motivo => {
      if (motivo.value == this.objetoTCE.motivo) {
        this.comboMotivo = motivo.value;
      }
    });

    this.detMotivos.forEach(detMotivo => {
      if (detMotivo.value == this.objetoTCE.detMotivo) {
        this.comboDetMotivo = detMotivo.value;
      }
    });

    if (this.objetoTCE.cnpj == undefined || this.objetoTCE.cnpj == '') {
      this.habilita = false;
    } else {
      this.habilita = true;
    }

    this.objetoEdit = item;

    this.flTipo = item.nomeConvenente ? 'true' : 'false';
  }

  onFlEnviadaChange(novoValor) {
    this.objetoTCE.flEnviada = novoValor;
  }

  finalizarTomadaDeConta() {
    this.listaEdit.forEach(item => {
      this.removerTCE(item, true);
    });

    this.listaEdit = [];

    let valida = true;

    this.listaTCE.forEach(element => {
      if (element.responsaveis.length == 0) {
        valida = false;
      }
    });

    if (valida) {
      this.tomadaDeContaService.salvarTomadaDeConta(this.listaTCE).subscribe(tce => {
        this.tomadaDeContaService.finalizarAnaliseTomadaDeConta(this.idModuloAnalise).subscribe(data => {
          this.alertService.mostraAlerta("", "Tomada de Conta finalizada com sucesso.");
          this.voltarParaTomadaDeconta();
        }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar a Tomada de Conta:" + error.mensagem);
        });
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar a Tomada de Conta:" + error.mensagem);
      });
    } else {
      this.alertService.mostraAlerta("Erro ao Finalizar", "Existem TCE's que não possuem responsável atribuído.");
    }
  }

  truncateText(text) {
    let numberOfWordsToTruncate = 10;

    if (text != undefined) {
      let separatedByWords = text.toString().split(" ");

      if (this.needTruncate(text)) {
        return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
      }
      else {
        return text;
      }
    }
  }

  needTruncate(text) {
    let separatedByWords;

    if (text != undefined) {
      separatedByWords = text.toString().split(" ");
    } else {
      separatedByWords = "A";
    }

    let numberOfWordsToTruncate = 10;

    return separatedByWords.length >= numberOfWordsToTruncate;
  }

  exibirCompleto(text) {
    this.alertService.mostraAlerta('', text);
  }

  onCPFAlterado(event) {

    let value = event.replace(/\D/g, '');
    
    if (value.length > 11) {
      this.habilita = true;

      const element = this.renderer.selectRootElement('.cnpj');
      setTimeout(() => {
        element.focus();
      }, 1);

      this.cpfConvInvalido = false;

      this.objetoTCE.cnpj = this.cnpj_mask(value);
      this.objetoTCE.cpfConv = undefined;

      this.validarCNPJ(this.cnpj_mask(value));

    } else {      
        this.validarCPFConv(this.objetoTCE.cpfConv);
        this.objetoTCE.cpfConv = this.cpf_mask(value);      
    }
  }

  cpf_mask(v) {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  } 

  validarCPFConv(cpf) {

    if (cpf != undefined) {
      cpf = cpf.replace(/[^\w\s]/gi, '');
      
      if (cpf == '') {
        this.cpfConvInvalido = true;
        return false;
      }

      if (cpf.length != 11) {
        this.cpfConvInvalido = true;        
        return false;
      }

      
      // Elimina CPFs invalidos conhecidos
      if (cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" ||
        cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" ||
        cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") {
        this.cpfConvInvalido = true;
        return false;
      }

      // Valida 1o digito
      let add = 0;
      for (let i = 0; i < 9; i++)
        add += parseInt(cpf.charAt(i)) * (10 - i);
      let rev = 11 - (add % 11);
      if (rev == 10 || rev == 11)
        rev = 0;
      if (rev != parseInt(cpf.charAt(9))) {
        this.cpfConvInvalido = true;
        return false;
      }

      // Valida 2o digito
      add = 0;
      for (let i = 0; i < 10; i++) {
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }
      rev = 11 - (add % 11);
      if (rev == 10 || rev == 11)
        rev = 0;
      if (rev != parseInt(cpf.charAt(10))) {
        this.cpfConvInvalido = true;
        return false;
      }
    }

    this.cpfConvInvalido = false;
    return true;
  }

  onCNPJAlterado(event) {
    let value = event.replace(/\D/g, '');
    if (value.length < 12) {
      this.habilita = false;
      this.objetoTCE.cnpj = undefined;
      this.objetoTCE.cpfConv = this.cpf_mask(value);

      const element = this.renderer.selectRootElement('.cpf');

      setTimeout(() => {
        element.focus();
      }, 1);

      this.validarCPFConv(this.cpf_mask(value));
      this.cnpjInvalido = false;

    } else {
      this.validarCNPJ(this.objetoTCE.cnpj);
      this.objetoTCE.cnpj = this.cnpj_mask(value);
    }
  }

  cnpj_mask(v) {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{2})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d)/, '$1/$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{4})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  }

  validarCNPJ(cnpj) {

    if (cnpj != undefined) {
      cnpj = cnpj.replace(/[^\d]+/g, '');
      if (cnpj == '') {
        this.cnpjInvalido = true;
        return false;
      }

      if (cnpj.length != 14) {
        this.cnpjInvalido = true;
        return false;
      }

      
      // Elimina CNPJs invalidos conhecidos
      if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999") {
        this.cnpjInvalido = true;
        return false;
      }

      let tamanho: any;
      let numeros: any;
      let digitos: any;
      let soma: any;
      let pos: any;
      let resultado: any;

      // Valida DVs
      tamanho = cnpj.length - 2
      numeros = cnpj.substring(0, tamanho);
      digitos = cnpj.substring(tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
          pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0)) {
        this.cnpjInvalido = true;
        return false;
      }

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
          pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1)) {
        this.cnpjInvalido = true;
        return false;
      }
    }

    this.cnpjInvalido = false;
    return true;
  }

  onDetalhamentoMotivoChange(detMotivo) {
    this.objetoTCE.detMotivo = detMotivo;
  }

  onMotivoChange(motivo) {
    this.objetoTCE.motivo = motivo;
  }

  modalResponsaveis(item) {
    this.apresentaModalResponsaveis("Responsáveis", item, ModalResponsavelTcePage);
  }

  apresentaModalResponsaveis(titulo: String, objeto: any, modalPage: any) {
    let modal = this.modalCtrl.create(modalPage, {
      tce: objeto,
      jurisdicionado: this.isJurisdicionado,
      isCGE: this.isCGE
    });
    modal.onDidDismiss(retornoModal => {

      if (retornoModal && retornoModal.salvar && this.isJurisdicionado) {

        // let index = this.listaTCE.indexOf(objeto.id);
        // this.listaTCE.splice(index, 1);

        // if (objeto.id != "0") {
        //     this.tomadaDeContaService.deletarTomadaDeConta(objeto.id).subscribe(data => {
        //         let index = this.listaTCE.indexOf(objeto.id);
        //         this.listaTCE.splice(index, 1);
        //     }, error => {
        //         this.alertService.mostraAlerta("", "Ocorreu um erro ao deletar a Tomada de Conta:" + error);
        //     });
        // }

        retornoModal.tce.responsaveis = retornoModal.tce.responsaveis.filter(function (element) {
          return element !== undefined;
        });

        this.listaTCE.forEach(item => {
          if (item.id === retornoModal.tce.id
            && item.nmSacc === retornoModal.tce.nmSacc
            && item.nmSic === retornoModal.tce.nmSic
            && item.nmPortaria === retornoModal.tce.nmPortaria
            && item.dano === retornoModal.tce.dano
            && item.danoFinal === retornoModal.tce.danoFinal
            && item.ds_situacao === retornoModal.tce.ds_situacao) {

            item.responsaveis = retornoModal.tce.responsaveis;
          }
        });

        // this.listaTCE.push(retornoModal.tce);

        this.alertService.mostraAlerta("", "Responsáveis salvos com sucesso.");

      }
    });
    modal.present();
  }

  printData() {

    var doc = new jsPDF("l");

    var totalPagesExp = "{total_pages_count_string}";

    var pageContent = function (data) {
      // HEADER
      doc.setFontSize(20);
      doc.setTextColor(40);
      doc.setFontStyle('normal');

      doc.text("Tomadas de Contas Especiais Registradas nesta Prestação de Contas", data.settings.margin.left + 15, 22);

      // FOOTER
      var str = "Page " + data.pageCount;
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + " of " + totalPagesExp;
      }
      doc.setFontSize(10);
      doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
    };

    var columns = [
      { title: "Nº SACC/e-Parcerias/SCC do Convênio", dataKey: "sacc" },
      { title: "Nº SIC", dataKey: "sic" },
      { title: "Portaria", dataKey: "portaria" },
      { title: "Data Public.", dataKey: "dataPortaria" },
      { title: "Convenente/Parceiro", dataKey: "nomeConv" },
      { title: "CPF Convenente/Parceiro", dataKey: "cpfConv" },
      { title: "Valor Convênio", dataKey: "valorConv" },
      { title: "Dano Inicial", dataKey: "danoInicial" },
      { title: "Dano Final", dataKey: "danoFinal" },
      { title: "Responsáveis Cadastrados?", dataKey: "resp" },
      { title: "Fato Gerador", dataKey: "fato" }
    ];

    let rows = [];

    this.listaTCE.forEach(element => {

      let resp;

      if (element.responsaveis.length == 0) {
        resp = "Não";
      } else {
        resp = "Sim";
      }

      var item = {
        "sacc": element.nmSacc != null ? element.nmSacc : "",
        "sic": element.nmSic != null ? element.nmSic : "",
        "portaria": element.nmPortaria != null ? element.nmPortaria : "",
        "dataPortaria": element.dataPublicacao != null ? element.dataPublicacao : "",
        "nomeConv": element.nomeConvenente != null ? element.nomeConvenente : "",
        "cpfConv": element.cpfConv != null ? element.cpfConv : "",
        "valorConv": this.formatarValorNumerico(element.valor) != null ? this.formatarValorNumerico(element.valor) : "",
        "danoInicial": element.dano != null ? this.formatarValorNumerico(element.dano) : "",
        "danoFinal": element.danoFinal != null ? this.formatarValorNumerico(element.danoFinal) : "",
        "resp": resp,
        "fato": element.situacao != null ? element.situacao + " - " + element.ds_situacao : ""
      };

      rows.push(item);
    });

    doc.autoTable(columns, rows, {
      //     theme: 'grid',
      //     addPageContent: pageContent,
      //     margin: { top: 30 },
      //     styles: {
      //         overflow: 'linebreak', // visible, hidden, ellipsize or linebreak
      //         columnWidth: 'auto'
      //     }
      // });

      theme: 'grid',
      addPageContent: pageContent,
      margin: {
        top: 30,
        left: 5
      },
      styles: {
        overflow: 'linebreak',
        columnWidth: 'wrap',
        fontSize: 7
      },
      columnStyles: {
        text: { columnWidth: 'auto' }
      }
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    doc.save('tce.pdf');
  }

  selecionarTodos(){
    setTimeout(()=>{
        this.listaTCE.forEach(
            item => item.checked = this.selecionarTodosChecked);            
    });
  }

  selecionarItem(){
      const totalItems = this.listaTCE.length;
      let checked = 0;
      this.listaTCE.map(obj => {
          if (obj.checked) checked++;
      });
      this.selecionarTodosChecked = checked == totalItems;
  }

  importarDoAnoAnterior() {

    this.alertService.mostraModalConfirmacao("Importar do Ano Anterior", 
        "Recomenda-se realizar a importação dos dados por meio do template de carga em massa."+
        "<br />Deseja continuar a importação dos registros do ano anterior mesmo assim?", 
        callback => {            
            if (callback) {
                this.loading = true;
                this.desabilitarImportacao = true;
                this.tomadaDeContaService.importarDoAnoAnterior(this.idModuloAnalise).subscribe(data => {
                    this.alertService.mostraAlerta("", data.mensagem);
                    this.listarTCE();
                }, error => {
                    console.log("erro: " + error.mensagem);
                    this.alertService.mostraAlerta("Erro ao importar", error.mensagem);
                    this.listarTCE();
                });
            }
        }
    );

  }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/tce/tce-exercicio/tce-exercicio.ts